import type { HTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

/**
 * Skeleton — loading placeholder with shimmer animation.
 * Uses the `skeleton` @utility from globals.css (compatible with light & dark mode).
 * Satisfies NFR-DS-2 (no spinners — always skeleton-shaped placeholders).
 */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('skeleton', className)} {...props} />
}
